export default "__VITE_ASSET__CjkfibZz__"